module.exports = __webpack_public_path__ + "static/bsas007.thumb-9187154f92ccd85d898d58edd76c1f48.jpg";